module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"our-team":"Our Team"},"ja":{"our-team":"弊社コンサルタント"}}')
  delete Component.options._Ctor
}
